namespace advisorop.services {
    
    export class IdentityService {

        static $inject = ["$http", "$rootRouter", "$q", "$cookies","generalService"];
        constructor(private $http: ng.IHttpService, private $rootRouter,
            private $q: ng.IQService, private $cookies,
            private generalService: GeneralService) {
        }

        login(user: domains.identity.ILoginFormModel): ng.IPromise<advisorop.domains.identity.LoginRet> {
            localStorage.removeItem("adminMode");
            return this.$http.post("/api/identity/login", user)
                .then((response: any) => {
                    if (response.data.err) {
                        throw new Error(`Username or password is not correct please try again`);
                    }

                    var loginRet: advisorop.domains.identity.LoginRet = {
                        retCode: 0,
                        twofEmails: null,
                        twofPhones: null
                    };

                    var user: advisorop.domains.identity.IUser = response.data;

                    if (user.twof) {
                        if (user.twofAskMethod) {
                            // Two factor authentication required, ask user for authentication method (phone or email)
                            loginRet.retCode = 2;
                            loginRet.twofPhones = user.twofPhones;
                            loginRet.twofEmails = user.twofEmails;
                            return loginRet;
                        } else {
                            // Two factor authentication required
                            loginRet.retCode = 3;
                            return loginRet;
                        }
                    }

                    this.generalService.goToLandingPage = true;

                    //const userinfo = this.getUserPromise()
                    //    .then(r => {})
                    //    .catch(err => {
                    //        toastr.info("Can not fetch userdata from server at this moment!");
                    //    });

                    loginRet.retCode = 1;
                    return loginRet;
                }, err => { throw new Error(err.data); });
        };

        verifyToken(user: domains.identity.ILoginFormModel): ng.IPromise<{}> {
            localStorage.removeItem("adminMode");
            return this.$http.post("/api/identity/login", user)
                .then((response: any) => {
                    if (response.data.err) {
                        throw new Error(`Username or password is not correct please try again`);
                    }

                    this.generalService.goToLandingPage = true;

                    //const userinfo = this.getUserPromise()
                    //    .then(r => { })
                    //    .catch(err => {
                    //        toastr.info("Can not fetch userdata from server at this moment!");
                    //    });

                    return 1;
                }, err => { throw new Error(err.data); });
        };

        changePassword(model: domains.identity.IChangePasswordModel): ng.IHttpPromise<{data?: string, warning?: string}> {
            return this.$http.post("/api/identity/changepassword", model);

        }

        /// Whether this deployment offers Salesforce sign-in, and what to call the button. The
        /// answer carries nothing else - not the consumer key, not the authorize URL - because the
        /// login screen is public and does not need them to start the flow.
        getSsoConfig(): ng.IHttpPromise<domains.identity.ISsoConfig> {
            return this.$http.get("/api/identity/sso-config");
        }

        /// The AdvisorOp logins a Salesforce identity resolved to, when it resolved to more than
        /// one. Readable only by the browser holding the selection ticket.
        getSsoChoices(): ng.IHttpPromise<domains.identity.ISsoChoices> {
            return this.$http.get("/api/identity/sso-choices");
        }

        /// Picks one of them. The nonce comes from getSsoChoices and ties this call to that ticket;
        /// the reference is opaque and means nothing outside it.
        selectSsoAccount(choice: string, nonce: string): ng.IHttpPromise<{ redirectTo: string }> {
            return this.$http.post("/api/identity/sso-select", { choice: choice, nonce: nonce });
        }

        getMyTwoFactorSetup(): ng.IHttpPromise<domains.identity.ITwoFactorSetup> {
            return this.$http.get("/api/identity/mytwofactorsetup");
        }

        /// Sets the caller's own mobile number. The server validates and normalises; the value sent
        /// from here is whatever the user typed.
        setMyTwoFactorPhone(phone: string): ng.IHttpPromise<domains.identity.ITwoFactorSetup> {
            return this.$http.post("/api/identity/mytwofactorphone", { phone: phone });
        }

        /// Adds an email address, and only when none is held. The server refuses a replacement.
        setMyTwoFactorEmail(email: string): ng.IHttpPromise<domains.identity.ITwoFactorSetup> {
            return this.$http.post("/api/identity/mytwofactoremail", { email: email });
        }

        /// Switches two-factor authentication on for the signed-in user. There is deliberately no
        /// matching "disable" here: by decision a user may turn their own second factor on but not
        /// off, so a session that has already been taken over cannot remove the control. Turning it
        /// off is an administrator action on the servicer and advisor login screens.
        enableMyTwoFactor(): ng.IPromise<domains.identity.IUser> {
            return this.$http.post("/api/identity/enablemytwofactor", {})
                .then((response: any) => {
                    // getUserPromise serves the user out of localStorage when it is there, so the
                    // cached copy has to be updated too or this screen keeps reporting the old
                    // state until the next sign-in.
                    var cached = localStorage.getItem("user");
                    if (cached) {
                        var user = <domains.identity.IUser>angular.fromJson(cached);
                        user.twoFactorEnabled = true;
                        localStorage.setItem("user", angular.toJson(user));
                    }
                    return <domains.identity.IUser>response.data;
                });
        }

        getUserPromise(): ng.IPromise<domains.identity.IUser> {

            // console.log(`User data requested / getting app version...`);

            this.generalService.loadAdvisorOpVersion();

            var deferred = this.$q.defer();
            //console.log("getUserPromise...");
            if (localStorage.getItem("user")) {
                //console.log("found in local storage...");
                deferred.resolve(<domains.identity.IUser>angular.fromJson(localStorage.getItem("user")));
            } else {
                // console.log("Fetching user data from the server...");
                this.$http.get("/api/identity/getuser")
                    .then(response => {
                        //console.log("data fetched");
                        localStorage.setItem("user", angular.toJson(response.data));
                        deferred.resolve(response.data);
                    })
                    .catch(response => {
                        //console.log("error during fetching data ...");
                        //location.href = "/";
                        this.logout();
                        deferred.reject(`Error ${response.status}  ${response.data}`);
                    });
            }

            return deferred.promise;
        };

        getUser(): domains.identity.IUser {

            var userData: domains.identity.IUser = {
                email: "",
                firstName: "",
                lastName: "",
                loginStatus: 0,
                loginStatusDesc: "Not authenticated",
                role: "none",
                systemLoginType: 0,
                systemLoginTypeDesc: "Not authorized",
                username: ""
            };


            //console.log("getUser executing...");

            if (!localStorage.getItem("user")) {
                //console.log("getUser: user does not exists in local storage, calling api...");
                this.$http.get("api/identity/getuser")
                    .then(response => {
                        //console.log("getUser: calling api success, storing user to local storage ...");
                        localStorage.setItem("user", JSON.stringify(response.data));
                        userData = <domains.identity.IUser>response.data;
                    })
                    .catch(response => {
                        //console.log(`getUser: calling api failed... Error ${response.status}: ${response.data}`);
                        toastr.error(`Error ${response.status}: ${response.data}`);
                        location.href = "/";
                    });                
            }
            else
                userData = <domains.identity.IUser>JSON.parse(localStorage.getItem("user"));

            return userData;
        }

        getUserFullName(): string {
            //console.log("getUserFullName");
            let fullName = "";
            if (!localStorage.getItem("user")) {                
                this.getUserPromise().then(response => {
                    let usr = response;
                    fullName = usr.firstName + " " + usr.lastName;
                });
            }
            else {
                let usr = <domains.identity.IUser>JSON.parse(localStorage.getItem("user"));
                fullName = usr.firstName + " " + usr.lastName;
            }
            return fullName;
        }

        getUserRole(): string {
            //console.log("getUserRole");
            let role = "";
            this.getUserPromise().then(response => {
                role = response.role;
            });
            return role;
        }

        logout() {

            localStorage.clear();

            //var cookies = this.$cookies.getAll();
            //console.log(cookies);
            //for (var c in cookies) {
            //    console.log("Clearing cookie");
            //    console.log(c);
            //    this.$cookies.remove(c);
            //}
            
            toastr.info("You have successfully logged out");
            
            // remove SAML redirect to advisorop
            //window.location.href = "/samlsp/logout";

            // instead of SAML logout just call our api
            this.$http.post("/api/identity/logout", {}).finally(() =>
            {
                location.href = "identity/login";
            });
        }

        forgotPassword(model: domains.identity.IForgotPasswordModel): ng.IHttpPromise<{}> {

            return this.$http.post("/api/identity/forgotpassword", model);
        }

        resetPassword(model: domains.identity.IResetPasswordModel): ng.IHttpPromise<{}> {

            return this.$http.post("/api/identity/resetpassword", model);
        }

        setupAccount(model: domains.identity.ISetupAccountModel): ng.IHttpPromise<{}> {

            return this.$http.post("/api/identity/setupaccount", model);
        } 

        impersonateUser(userId: string): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/identity/impersonate/${userId}`, { userId: userId });
        }

        endImpersonation(): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/identity/endimpersonation/`, null);
        }

        getUserHierarchy(parentUserId: string): ng.IHttpPromise<domains.IUsersHierarchy[]> {
            return this.$http.get(`/api/general/userhierarchy/${parentUserId}`);
        }

        getChildAdvisors(): ng.IHttpPromise<domains.IUsersHierarchy[]> {
            return this.$http.get(`/api/general/childadvisors`);
        }

        saveUserHierarchy(userHierarchy: domains.IUsersHierarchy): ng.IHttpPromise<any> {
            return this.$http.post(`/api/general/userhierarchy`, userHierarchy);
        }

        deleteUserHierarchy(userHierarchyId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/general/userhierarchy/${userHierarchyId}`);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("identityService", IdentityService);
}